import type { Voice } from '@/features/voice/domain/models/voice'
import type { Speech } from '../models/speech'
import { SpeechService } from '../../data/speech.service'
import { storeSpeech } from './store-speech'

export const createSTSSpeech = async (
  scriptId: string,
  fileId: string, // The file id in audiostack servers
  voice: Voice,
  expressive = false
): Promise<Speech> => {
  const speech = await SpeechService.createSpeechToSpeech(
    fileId,
    voice.id,
    expressive
  )
  storeSpeech(speech, scriptId, voice, 1, expressive)
  return speech
}
